/* unplugin-vue-components disabled */import { render } from "./feed-header.vue?vue&type=template&id=83fe6d36&scoped=true"
import script from "./feed-header.vue?vue&type=script&lang=js"
export * from "./feed-header.vue?vue&type=script&lang=js"

import "./feed-header.vue?vue&type=style&index=0&id=83fe6d36&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83fe6d36"],['__file',"src/pages/pulse/feed/feed-header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "83fe6d36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('83fe6d36', __exports__)) {
    api.reload('83fe6d36', __exports__)
  }
  
  module.hot.accept("./feed-header.vue?vue&type=template&id=83fe6d36&scoped=true", () => {
    api.rerender('83fe6d36', render)
  })

}


export default __exports__